import { RivalsAppProps, RivalsPageProps } from "rivals/Context";
import ProtectedPage from "rivals/components/app/ProtectedPage/WithRedux/container";
import StrictlyProtectedPage from "rivals/components/app/StrictlyProtectedPage";
import SubscriptionNew from "rivals/components/pages/User/Subscriptions/New/container";
import { getRailsConstants as getRailsConstantsAction } from "rivals/redux/rails/actions";
import { RailsConstantsKeys } from "rivals/redux/rails/reducer";
import { getAddonsForSubscription } from "rivals/redux/subscriptionAddons/actions";
import {
  getAddress,
  getBillingInformation,
  getSubscriptions
} from "rivals/redux/user/actions";
import { redirectToOn3TransitionPage } from "rivals/shared/utils/redirects";
import styles from "./SubscriptionsNew.module.scss";

const COMPONENTS = [
  RailsConstantsKeys.BILLING_INFORMATION,
  RailsConstantsKeys.SUBSCRIPTION_PRICING
];

function SubscriptionsNewPage(disableSubscriptions: boolean): JSX.Element {
  return (
    <main className={styles.wrapper} role="main">
      <ProtectedPage>
        <StrictlyProtectedPage>
          <SubscriptionNew disableSubscriptions={disableSubscriptions} />
        </StrictlyProtectedPage>
      </ProtectedPage>
    </main>
  );
}

SubscriptionsNewPage.getInitialProps = async (
  props: RivalsAppProps
): Promise<RivalsPageProps & { disableSubscriptions: boolean }> => {
  const {
    isServer,
    store: { dispatch },
    res
  } = props;

  if (props.flipperSettings?.disableSubscriptions) {
    redirectToOn3TransitionPage(res);
    return { disableSubscriptions: true, isServer };
  }

  dispatch(getRailsConstantsAction(COMPONENTS));
  dispatch(getBillingInformation());
  dispatch(getAddress());
  dispatch(getSubscriptions());
  dispatch(getAddonsForSubscription());

  return {
    disableSubscriptions: !!props?.flipperSettings?.disableSubscriptions,
    isServer
  };
};

export default SubscriptionsNewPage;
